/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Google_Client_IdInputs */

const en_admin_settings_fields_google_client_id = /** @type {(inputs: Admin_Settings_Fields_Google_Client_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client ID`)
};

const zh_admin_settings_fields_google_client_id = /** @type {(inputs: Admin_Settings_Fields_Google_Client_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客户端 ID`)
};

/**
* | output |
* | --- |
* | "Client ID" |
*
* @param {Admin_Settings_Fields_Google_Client_IdInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_google_client_id = /** @type {((inputs?: Admin_Settings_Fields_Google_Client_IdInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Google_Client_IdInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_google_client_id(inputs)
	return zh_admin_settings_fields_google_client_id(inputs)
});
export { admin_settings_fields_google_client_id as "admin.settings.fields.google_client_id" }